// extracted by mini-css-extract-plugin
module.exports = {"balance":"balances_balance__4X2Le","iconBox":"balances_iconBox__36Cm8","label":"balances_label__22mNx"};